import { render, staticRenderFns } from "./MessageRegisterConfirm.vue?vue&type=template&id=0a04df8c&lang=pug"
import script from "./MessageRegisterConfirm.vue?vue&type=script&lang=ts"
export * from "./MessageRegisterConfirm.vue?vue&type=script&lang=ts"
import style0 from "./MessageRegisterConfirm.vue?vue&type=style&index=0&id=0a04df8c&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports